import React from "react"
import { useEffect, useState, useRef } from "react"
import {
  Badge,
  Button,
  Card,
  Navbar,
  Nav,
  Table,
  Container,
  Row,
  Col,
  Modal
} from "react-bootstrap";
import { Link } from 'react-router-dom';
import BonusCreateModal from "components/Bonus/BonusCreateModal"
import Nestable from 'react-nestable';
import './css/style.css';
import { useParams } from 'react-router-dom';
import toast, { Toaster } from "react-hot-toast"
import API from "components/Apis/API"
import $ from "jquery"
import { useDownloadExcel } from "react-export-table-to-excel"
import { useForm } from "react-hook-form"
import jsPDF from 'jspdf';
import 'jspdf-autotable';

const BonusOrgChart = () => {
  const [show, setShow] = useState(false)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  const [showImport, setShowImport] = useState(false)
  const handleImportClose = () => setShowImport(false)
  const handleImportShow = () => setShowImport(true)

  const { id } = useParams();
  const [Result, setResult] = useState([]);
  const [Period, setPeriod] = useState([]);
  const tableRef = useRef(null)
  const [isDownloading, setIsDownloading] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]);


  const fetchData = async () =>
  {
    const toastId = toast.loading("Loading data...")

    const url  = "admin/bonus/periods/"+id+"/unsort_result"

    const response  = await API.getData(url)
    const data = response
    if (data.status) {
      setResult(data.data.result)
      setPeriod(data.data.period)
    }

    toast.dismiss(toastId)
  }

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;

    // If checkbox is checked, add the value to the array
    if (checked) {
      setSelectedValues([...selectedValues, value]);
    } else {
      // If unchecked, remove the value from the array
      setSelectedValues(selectedValues.filter((item) => item !== value));
    }
    console.log(selectedValues);
  };

  const updateFailure = async (e,id) =>
  {
    const toastId = toast.loading("Saving data...")

    const url  = "admin/bonus/result/"+id+"/update_failure"
    let famount = $("#famount-"+id).val()
    let freason = $("#freason-"+id).val()
    let percentage = $("#percentage-"+id).val()
    let revenue = $("#revenue-"+id).val()

    let formData = new FormData();
    formData.append("famount",famount)
    formData.append("freason",freason)
    formData.append("percentage",percentage)
    formData.append("revenue",revenue)

    const response  = await API.postData(url,formData)
    toast.dismiss(toastId)
  }

  const calculateBonus = async () =>
  {
    const toastId = toast.loading("Saving data...")
    const url  = "admin/bonus/periods/"+id+"/calculate_bonus"
    const response  = await API.postData(url)
    if (response.status) {
      setResult(response.data)
    }
    toast.dismiss(toastId)
  }
  

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Bonus - " + Math.floor(Date.now() / 1000),
    sheet: "Main",
  })

  const download = async () =>
  {
    await setIsDownloading(true)
    await onDownload()
    await setIsDownloading(false)

  }

  function formatDate(isoDate) {
    const date = new Date(isoDate);
  
    const day = String(date.getDate()).padStart(2, '0');
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();
  
    return `${day}, ${month} ${year}`;
  }

  const askDelete = async (id,person) => {
    toast(
      (t) => (
        <span style={{ textAlign: "center" }}>
          Do you want to delete this record ({person})?<br></br>
          <button
            className='btn btn-primary btn-xs'
            onClick={() => deleteRecord(id,t.id)}
          >
            Yes
          </button>
          <button
            className='btn btn-primary btn-xs'
            onClick={() => toast.dismiss(t.id)}
          >
            No
          </button>
        </span>
      )
    )
  }
  const deleteRecord = async (id,tid) =>
  {
    toast.dismiss(tid)
    const toastId = toast.loading("Deleting data...")
    const url  = "admin/bonus/result/"+id+"/delete"
    const response  = await API.postData(url)
    if (response.status) {
      setResult(response.data)
    }
    toast.dismiss(toastId)
  }
  const addNewRecord = async () =>
  {
    const formData = new FormData($(".add-form")[0])
    const toastId = toast.loading("Saving data...")
    const url  = "admin/bonus/periods/"+id+"/result/add"
    const response  = await API.postData(url,formData)
    if (response.status) {
      await setResult([])
      await setResult(response.data)
      handleClose()
    }
    toast.dismiss(toastId)
  }
  const exportToPdf = async () => {
    const toastId = toast.loading("Exporting PDF...")
    const input = tableRef.current;
    await setIsDownloading(true)
    
    const doc = new jsPDF();

    const title = Period.name;
    const pageWidth = doc.internal.pageSize.getWidth();
    const fontSize = 16;
    doc.setFontSize(fontSize); 
    const titleWidth = doc.getStringUnitWidth(title) * fontSize / doc.internal.scaleFactor;
    const titleX = (pageWidth - titleWidth) / 2; 
    const titleY = 20; 
    doc.text(title, titleX, titleY);

    const subtitle = formatDate(Period.start_date) +" - "+formatDate(Period.end_date);
    const subtitleFontSize = 12;
    doc.setFontSize(subtitleFontSize); 
    const subtitleWidth = doc.getStringUnitWidth(subtitle) * subtitleFontSize / doc.internal.scaleFactor;
    const subtitleX = (pageWidth - subtitleWidth) / 2; 
    const subtitleY = titleY + 10; 
    doc.text(subtitle, subtitleX, subtitleY);


    const startY = titleY + 20;

    doc.autoTable({
      html: '#result-table', 
      startY: startY,
    });
    doc.save("period-"+id+".pdf");
    console.log(selectedValues)
    await setIsDownloading(false)
    toast.dismiss(toastId)
  };
  const handleChange = (e, id, field) => {
    const updatedData = Result.map(item => {
      if (item.id === id) {
        return {
          ...item,
          [field]: e.target.value
        };
      }
      return item;
    });
    setResult(updatedData);
  };

  const getGroupName = (groupName) => {
    switch (groupName) {
      case 0:
        return 'MEMBER';
      case 1:
        return 'SOLO';
      case 2:
        return 'GROUP';
      case 3:
        return 'SUPERVISOR';
      default:
        return 'MEMBER';  
    }
  };
  
  // upload file
  const fileInputRef = useRef(null);
  const handleFileUpload = () => {
    fileInputRef.current.click();
  };
  const handleFileInputChange = async (event) => {
    const file = event.target.files[0];
    if (file && file.name.endsWith('.xls')) {
      const toastId = toast.loading("Uploading file...")
      const formData = new FormData();
      formData.append('file', file);
      //upload file
      const url  = "admin/bonus/periods/"+id+"/result/import"
      const response  = await API.postData(url,formData)
      if (response.status) {
        //await setResult([])
        //await setResult(response.data)
        handleClose()
      }
      toast.dismiss(toastId)
      //upload file end

    } else {
      toast.error("Only .xls file format is allowed, please download the template and try again!")
    }
  };
  // end file upload

  const {
    handleSubmit
  } = useForm()

  useEffect( () => {
     fetchData()
  }, [])


  return (
    <>
      <Toaster position='bottom-right' />
      <Container fluid>
        <Row>
          <Col md="12">
            <Card className="strpied-tabled-with-hover">
            <Card.Header>
                <Card.Title as="h4">
                  Manage Bonus
                  <Link
                      className='btn btn-primary btn-sm tbtn terminal_1'
                      style={{ margin: "5px", float: "right" }}
                      to="/admin/app/bonus"
               
                  >Go Back</Link>
                  <Link
                      className='btn btn-primary btn-sm tbtn terminal_1'
                      style={{ margin: "5px", float: "right" }}
                      to={`/admin/app/bonus-org-chart/${id}`}
               
                  >Manage Structure</Link>
                  <a style={{ margin: "5px", float: "right" }} className="btn btn-success btn-sm" onClick={download}>Download Excel</a>
                  <a style={{ margin: "5px", float: "right" }} className="btn btn-success btn-sm" onClick={exportToPdf}>Download PDF</a>
                  <a style={{ margin: "5px", float: "right" }} className="btn btn-primary btn-sm" onClick={()=>calculateBonus()}>Calculate Bonus</a>
                  <a style={{ margin: "5px", float: "right" }} className="btn btn-primary btn-sm" onClick={handleFileUpload}>Upload Data</a>
                  <input type="file" ref={fileInputRef} style={{ display: 'none' }} onChange={handleFileInputChange} />
                  <a style={{ margin: "5px", float: "right" }} className="btn btn-primary btn-sm" onClick={()=>handleShow()}>Add New Record</a>
    
                
                </Card.Title>
                <p className="card-category">
                  Calculate bonus
                </p>

            </Card.Header>
            <Card.Body className="">
              <Row>
                <Col md="12">
                    <table id="result-table" className="table oldOrders table-result table-hover table-striped" ref={tableRef}>
                      {!isDownloading ? (
                        <thead>
                          <tr>
                            <th>Select</th>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Role</th>
                            <th>Gross Margin</th>
                            <th>Percentage (%)</th>
                            <th>Failure Amount</th>
                            <th>Failure Reasons</th>
                            <th>Final Bonus</th>
                            <th>Action</th>
                            </tr>
                        </thead>
                        ) : 
                        (
                        <thead>
                          <tr>
                            
                            <th>Name</th>
                            <th>Role</th>
                            <th>Total Gross Margin</th>
                            <th>Gross Margin</th>
                            <th>Percentage (%)</th>
                            <th>Failure Amount</th>
                            <th>Failure Reasons</th>
                            <th>Final Bonus</th>
                            </tr>
                        </thead>)
                        }
                        <tbody>
                        {Result.map((row, i) => (
                          <tr key={i}>
                              {!isDownloading ? (
                                  <>
                                      <td><input type="checkbox" value={row.id} checked={selectedValues.includes(String(row.id))} onChange={handleCheckboxChange} /> </td>
                                      <td>{row.id}</td>
                                      <td>{row.name}</td>
                                      <td>{getGroupName(row.group_name)}</td>
                                      <td>
                                          <input 
                                              onBlur={(e) => updateFailure(e, row.id)} 
                                              placeholder={"Gross margin for " + row.name} 
                                              className="form-control" 
                                              id={"revenue-" + row.id} 
                                              type="number" 
                                              value={row.revenue} 
                                              onChange={(e) => handleChange(e, row.id, 'revenue')} 
                                          />
              
                                          <p style={{fontSize:"14px"}}>
                                            Total: {row.c_revenue}
                                          </p>
                                      </td>
                                      <td>
                                          <input 
                                              onBlur={(e) => updateFailure(e, row.id)} 
                                              placeholder={"Percentage bonus for " + row.name} 
                                              className="form-control" 
                                              id={"percentage-" + row.id} 
                                              type="number" 
                                              value={row.percentage} 
                                              onChange={(e) => handleChange(e, row.id, 'percentage')} 
                                          />
                                      </td>
                                      <td>
                                          <input 
                                              onBlur={(e) => updateFailure(e, row.id)} 
                                              placeholder={"Amount to be deducted from " + row.name} 
                                              className="form-control" 
                                              id={"famount-" + row.id} 
                                              type="number" 
                                              value={row.failure_amount} 
                                              onChange={(e) => handleChange(e, row.id, 'failure_amount')} 
                                          />
                                          <p style={{fontSize:"14px"}}>
                                            Team: {row.c_failure_amount}<br></br>
                                            Total: {row.c_failure_amount + row.failure_amount}
                                          </p>
                                      </td>
                                      <td>
                                          <textarea 
                                              onBlur={(e) => updateFailure(e, row.id)} 
                                              placeholder={"Deduction reasons for " + row.name} 
                                              className="form-control" 
                                              id={"freason-" + row.id}
                                          >
                                              {row.failure_reason}
                                          </textarea>
                                      </td>
                                      <td>{row.final_bonus}</td>
                                      <td>
                                          <a className="btn btn-warning btn-xs" onClick={() => askDelete(row.id, row.name)}>Delete</a>
                                      </td>
                                  </>
                              ) : (
                                <>
                                  {row.group_name !== 2 && !selectedValues.includes(String(row.id)) && (
                                    <>
                                      <td>{row.name}</td>
                                      <td>{getGroupName(row.group_name)}</td>
                                      <td>{row.c_revenue}</td>
                                      <td>{row.revenue}</td>
                                      <td>{row.percentage}</td>
                                      <td>
                                        <span>{row.failure_amount}</span>
                                      </td>
                                      <td>
                                        <span>{row.failure_reason}</span>
                                      </td>
                                      <td>{row.final_bonus}</td>
                                    </>
                                  )}
                                  </>
                              )}
                          </tr>
                      ))}

                        </tbody>
                    </table>
                </Col>
              </Row>
              
            </Card.Body>
            </Card>
          </Col>
          
        </Row>
      </Container>
      <Modal
        show={show}
        onHide={handleClose}
        className=' bd-example-modal-lg'
      >
        <form onSubmit={handleSubmit(addNewRecord)} className='add-form'>
          <Modal.Header>
            <Modal.Title style={{ width: "100%", margin: "0 0 0" }}>
              Add New Record
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ paddingTop: "10px" }}>
            <Table
              className='table-hover table-striped'
              style={{ width: "100%", margin: "0 0 0" }}
            >
              <tbody>
                <tr>
                  <th>Name</th>
                  <td>
                    <input
                      name='name'
                      type='text'
                      className='form-control mt-1 modalInput'
                      placeholder='Enter employee name'
                      style={{textTransform:"uppercase"}}
                    />
                  </td>
                  <th>Gross Margin</th>
                  <td>
                    <input
                      name='revenue'
                      type='number'
                      className='form-control mt-1 modalInput'
                      placeholder='Enter gross margin'
                    />
                  </td>
                </tr>
                
              </tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={handleClose}>
              Close
            </Button>
            <Button variant='primary' type='submit'>
              Save Changes
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
  
    </>
  );
}

export default BonusOrgChart;
